import {useContext, useEffect, useState} from 'react'
import {ScreenSizeContext} from './context'

const useScreenWidth = (): number | undefined => {
  const {screenWidth} = useContext(ScreenSizeContext)
  const [localScreenWidth, setLocalScreenWidth] = useState(screenWidth)

  useEffect(() => {
    setLocalScreenWidth(screenWidth)
  }, [screenWidth])

  return localScreenWidth
}

export default useScreenWidth
